import localforage from 'localforage'
import { isEmpty } from 'lodash'
import { setHttpToken, setHttpBaseUrl } from '../../../helpers'

export const getUsersData = ({ commit, dispatch }, query='') => {
    const queryParams = parseQueryString(query);
    
    if(query == ''){
        query = '?perPage=1000';
    }
    let url = process.env.VUE_APP_SMART_ART_API_URL + 'api/users/list'+ query;
    return window.axios.get(url).then((response) => {
        if(queryParams.user_list_type == 'internal_users_list'){
            commit('SET_INTERNAL_USERS_LIST_DATA', response.data.data);
        }else{
            commit('SET_USERS_LIST_DATA', response.data.data);
        }
        
        return response.data;
    }).catch((error) => {
        dispatch("auth/errorHandler",error.response.status,{ root:true });
        commit('SET_ALERT', 'warning', { root: true })
        commit('SET_ALERT_MESSAGE', 'Something went wrong SSO', { root: true })
        return false;
    })
};

function parseQueryString(queryString) {
    const params = new URLSearchParams(queryString);
    let queryObject = {};
    for (let [key, value] of params.entries()) {
        queryObject[key] = value;
    }
    return queryObject;
}